import React from "react";

class HeaderSearchInput extends React.Component {
  componentDidMount() {
    var searchDiv = document.querySelectorAll(".header-search")[0];
    var searchButton = document.querySelectorAll(".search-button")[0];
    searchButton.addEventListener("click", function() {
      if (searchDiv.style.maxHeight < "1") {
        searchDiv.style.maxHeight = 60 + "px";
        searchButton.classList.add("cross-button");
      } else {
        searchDiv.style.maxHeight = 0 + "px";
        searchButton.classList.remove("cross-button");
      }
    });
  }

  render() {
    return (
      <form
        className="header-search-input"
        action="https://agriculture.vic.gov.au/search"
      >
        <input
          type="text"
          name="query"
          placeholder="Search"
          aria-label="search"
        />
        <button
          type="submit"
          className="search-icon fa fa-search"
          aria-label="Submit"
        ></button>
      </form>
    );
  }
}

export default HeaderSearchInput;
